import { Money } from '@principle-theorem/accounting';
import {
  DEFAULT_STRIPE_INVOICE_STATUS,
  IStripeInvoice,
  IStripeInvoiceData,
  StripeInvoiceStatus,
} from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';
import type Stripe from 'stripe';

export class StripeInvoice {
  static init(overrides: AtLeast<IStripeInvoice, 'invoice'>): IStripeInvoice {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static fromStripeData(invoice: Stripe.Invoice): IStripeInvoiceData {
    if (!invoice.id) {
      throw new Error('Invoice ID is required');
    }

    return {
      id: invoice.id,
      status: invoice.status ?? DEFAULT_STRIPE_INVOICE_STATUS,
      number: `${invoice.number}`,
      total: Money.fromCents(invoice.total),
      amountPaid: Money.fromCents(invoice.amount_paid),
      hostedInvoiceUrl: invoice.hosted_invoice_url ?? undefined,
      rawData: invoice,
    };
  }

  static isUnpaid(invoice: IStripeInvoice): boolean {
    return !StripeInvoice.isPaid(invoice) && !StripeInvoice.isVoid(invoice);
  }

  static isPaid(invoice: IStripeInvoice): boolean {
    return [StripeInvoiceStatus.Paid].includes(
      invoice.invoice.status as StripeInvoiceStatus
    );
  }

  static isVoid(invoice: IStripeInvoice): boolean {
    return [
      StripeInvoiceStatus.Void,
      StripeInvoiceStatus.Uncollectible,
    ].includes(invoice.invoice.status as StripeInvoiceStatus);
  }
}
